import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {partnersApi} from '../api';
import {UpdatePartnerDTO} from '../model';
import {useCallback} from 'react';
import {useNotifications} from '../../../shared';

export const usePartnerById = (partnerId: string) => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const getPartner = useQuery({
    queryKey: ['partner', partnerId],
    queryFn: () => partnersApi.getPartnerById(partnerId),
    enabled: !!partnerId,
  });

  const refetchPartner = useCallback(() => {
    queryClient.invalidateQueries({queryKey: ['partner', partnerId], refetchType: 'all'});
    queryClient.invalidateQueries({queryKey: ['partners', 'infinite'], refetchType: 'all'});
  }, [queryClient, partnerId]);

  const updatePartnerMutation = useMutation({
    mutationFn: (data: UpdatePartnerDTO) => partnersApi.updatePartner(partnerId, data),
    onSuccess: () => {
      refetchPartner();
      createNotification({
        title: 'Партнер успешно обновлен',
        name: 'updatePartner',
        theme: 'success',
      });
    },
  });

  const updatePartnerLogoMutation = useMutation({
    mutationFn: (logoUploadId: string) => partnersApi.updatePartnerLogo(partnerId, logoUploadId),
    onSuccess: () => {
      refetchPartner();
      createNotification({
        title: 'Логотип партнера успешно обновлен',
        name: 'updatePartnerLogo',
        theme: 'success',
      });
    },
  });

  return {
    getPartner,
    refetchPartner,
    updatePartnerMutation,
    updatePartnerLogoMutation,
  };
};
